<template>
      <div class="contactTypeCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'contactType', params: {} }">
          Contact Type
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'contactTypeCreate', params: {} }">
            Create Contact Type
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Contact Type</v-card-title>
          <v-card-text>
            <contactType-form></contactType-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import ContactTypeForm from './ContactTypeForm.vue';

    export default {
      name: 'contactType',
      components: {
        ContactTypeForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    